var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6475_35300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.52679 0.587695C4.70759 0.225781 5.07924 0 5.48438 0H9.51562C9.92076 0 10.2924 0.225781 10.4732 0.587695L10.7143 1.0625H13.9286C14.5212 1.0625 15 1.5373 15 2.125C15 2.7127 14.5212 3.1875 13.9286 3.1875H1.07143C0.478795 3.1875 0 2.7127 0 2.125C0 1.5373 0.478795 1.0625 1.07143 1.0625H4.28571L4.52679 0.587695ZM1.07143 4.25H13.9286V14.875C13.9286 16.0471 12.9676 17 11.7857 17H3.21429C2.03237 17 1.07143 16.0471 1.07143 14.875V4.25ZM4.28571 6.375C3.99107 6.375 3.75 6.61406 3.75 6.90625V14.3438C3.75 14.6359 3.99107 14.875 4.28571 14.875C4.58036 14.875 4.82143 14.6359 4.82143 14.3438V6.90625C4.82143 6.61406 4.58036 6.375 4.28571 6.375ZM7.5 6.375C7.20536 6.375 6.96429 6.61406 6.96429 6.90625V14.3438C6.96429 14.6359 7.20536 14.875 7.5 14.875C7.79464 14.875 8.03571 14.6359 8.03571 14.3438V6.90625C8.03571 6.61406 7.79464 6.375 7.5 6.375ZM10.7143 6.375C10.4196 6.375 10.1786 6.61406 10.1786 6.90625V14.3438C10.1786 14.6359 10.4196 14.875 10.7143 14.875C11.0089 14.875 11.25 14.6359 11.25 14.3438V6.90625C11.25 6.61406 11.0089 6.375 10.7143 6.375Z",
    fill: "#32304E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6475_35300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenDelete);
export default __webpack_public_path__ + "static/media/token_delete.957f5bd4e0d378cbbca44efafb4a41cb.svg";
export { ForwardRef as ReactComponent };